var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-solution"}},[_c('solution-form',{attrs:{"is-create":true,"solution-info":_vm.solutionInfoForCreate,"require-clauses-option":_vm.requireClauses,"submit":_vm.createSolution}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }